

export default {
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: +process.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE, //parses string to int
  service: 'beback-react',
  env: process.env.REACT_APP_MR_STAGE
}